import React from 'react';
import { Select, SelectProps, SxProps, Theme, useTheme } from '@mui/material';

const style: SxProps<Theme> = {
  borderRadius: '4px',
  height: 32,
  fontSize: '0.875rem',
  '& .MuiInputBase-input': {
    padding: '8px',
  },
  '& .MuiList-root': {
    paddingTop: '0',
  },
};

const shouldApplyConditionalStyling = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.length;
  }

  return value !== undefined;
};

const StyledFilledSelect: React.FC<Omit<SelectProps, 'variant'>> = ({
  children,
  value,
  ...rest
}) => {
  const theme = useTheme();

  const conditionalStyling = shouldApplyConditionalStyling(value)
    ? {
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.primary.dark,
        },
        backgroundColor: theme.palette.primary.main,
        '.MuiSvgIcon-root ': {
          fill: theme.palette.primary.contrastText,
        },
      }
    : {};

  return (
    <Select
      {...rest}
      value={value}
      variant={'filled'}
      disableUnderline
      MenuProps={{
        slotProps: {
          paper: {
            sx: { borderRadius: '6px' },
          },
          list: {
            sx: { padding: 0 },
          },
        },
      }}
      sx={{ ...style, ...conditionalStyling, ...rest.sx }}
    >
      {children}
    </Select>
  );
};

export default StyledFilledSelect;
